import kaplay from "kaplay";
import { gameScene } from "./game.js";

// Initialize Kaplay
const k = kaplay({
  background: "#05021a",
});

k.setGravity(0);

// --- ASSET LOADING ---
k.loadSprite("player-avatar", "sprites/player.png", {
  sliceX: 8,
  anims: {
    idle: { from: 0, to: 3, speed: 7, loop: true },
    punch: { from: 4, to: 5, speed: 14, loop: false },
    charged: { from: 6, to: 6, speed: 1, loop: false },
    hurt: { from: 7, to: 7, speed: 1, loop: false },
  },
});
k.loadSprite("foe-avatar", "sprites/enemy.png", {
  sliceX: 8,
  anims: {
    idle: { from: 0, to: 3, speed: 6, loop: true },
    punch: { from: 4, to: 5, speed: 11, loop: false },
    charged: { from: 6, to: 6, speed: 1, loop: false },
    hurt: { from: 7, to: 7, speed: 1, loop: false },
  },
});
k.loadSprite("bean", "sprites/bean.png"); // Power-up sprite
k.loadSound("sfx_punch", "audio/punch.wav");
k.loadSound("sfx_hurt", "audio/hurt.wav");
k.loadSound("sfx_combo", "audio/deck_ui_toast.wav");
k.loadSound("sfx_charge", "audio/deck_ui_slider_up.wav");
k.loadSound("sfx_break", "audio/deck_ui_hide_modal.wav");
k.loadSound("sfx_start", "audio/deck_ui_launch_game.wav");
k.loadSound("sfx_menu", "audio/menu.wav");
k.loadSound("bg_theme", "audio/music_zapsplat_game_music_action_fast_euro_house_pumping_fun_arcade_rave_024.mp3");

// UI Sounds
k.loadSound("sfx_ui_select", "audio/deck_ui_default_activation.wav");
k.loadSound("sfx_ui_show", "audio/deck_ui_show_modal.wav");
k.loadSound("sfx_ui_hide", "audio/deck_ui_hide_modal.wav");
k.loadSound("sfx_ui_nav", "audio/deck_ui_navigation.wav");

// Power-up Sounds
k.loadSound("sfx_powerup_health", "audio/deck_ui_toast.wav");
k.loadSound("sfx_powerup_speed", "audio/deck_ui_slider_up.wav");
k.loadSound("sfx_powerup_damage", "audio/deck_ui_bumper_end_02.wav");


k.loadSprite("background-space", "sprites/aiwon.23_perfect_wallpaper_for_laptop_with_discret_shadows_and__05ebe6b4-d29e-4460-8e19-3b669ba224ac.png");
k.loadSprite("player-portrait", "sprites/player_portrait.png");
k.loadSprite("enemy-portrait", "sprites/enemy_portrait.png");
k.loadSprite("vignette", "sprites/vignette.png");
k.loadSprite("font_arcade", "sprites/font_arcade.png", {
    sliceX: 35,
    sliceY: 5,
    chars: "abcdefghijklmnopqrstuvwxyz0123456789!?'()[]*+,-./:;\" "
});

// --- SCENES ---
gameScene(k); // This function will define the "game" scene

// --- START ---
k.go("game");